import { Box, Select as MuiSelect, MenuItem as MuiMenuItem, MenuList as MuiMenuList, Paper } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export const Label = styled('label')<{ disabled?: boolean }>`
  ${({ theme, disabled }) => css`
    display: block;
    font-size: 14px;
    line-height: 14px;
    font-weight: 500;
    color: ${theme.colors.gray.dark};
    margin-bottom: 6px;
    opacity: ${disabled ? 0.6 : 1};
  `}
`

export const SelectWrapper = styled.div`
  width: 100%;
  min-width: 0;
`

export const Placeholder = styled('span')`
  ${({ theme }) => css`
    font-size: 16px;
    font-weight: 400;
    opacity: 0.5;
    color: ${theme.colors.gray.dark};
  `}
`

export const SelectedValue = styled('span')`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
  width: 100%;
  min-width: 0;
`

export const IconWrapper = styled(Box)<{ error?: boolean }>`
  ${({ theme, error }) => css`
    display: flex;
    align-items: center;
    pointer-events: auto;
    color: ${error ? theme.colors.error.color : theme.colors.gray.dark};

    &[data-disabled='true'] {
      pointer-events: none;
      opacity: 0.5;
    }
  `}
`

export const Select = styled(MuiSelect)`
  ${({ theme, error, disabled }) => css`
    width: 100%;
    min-width: 0;
    height: 48px;
    border-radius: 8px;
    background: ${disabled ? theme.colors.gray.disabled : 'transparent'} !important;
    padding-top: 1px;

    .MuiOutlinedInput-notchedOutline {
      border: 1px solid !important;
      border-color: ${!error ? theme.colors.gray.dark : theme.colors.error.color} !important;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.gray.dark} !important;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border: 2px solid ${error ? theme.colors.error.color : theme.colors.primary}!important;
    }

    &.Mui-disabled .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline {
      border-color: ${theme.colors.border.disabled} !important;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: ${disabled
        ? theme.colors.border.disabled
        : error
          ? theme.colors.error.color
          : theme.colors.primary} !important;
    }

    .MuiSelect-select {
      display: flex;
      padding: 12px 14px !important;
      padding-right: 10px !important;
      overflow: hidden !important;
      text-overflow: ellipsis;
      white-space: nowrap;
      min-width: 0;
    }

    &.Mui-disabled,
    .MuiOutlinedInput-root.Mui-disabled,
    .MuiSelect-select.Mui-disabled {
      cursor: not-allowed !important;
    }
  `}
`

export const MenuPaper = styled(Paper)`
  ${({ theme }) => css`
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border-radius: 8px;
    overflow: auto;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1) !important;
    min-width: max-content;

    &::-webkit-scrollbar {
      width: 8px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 8px;
    }
    &::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.background.hover};
      border-radius: 8px;
      transition: background-color 0.3s ease;
    }
    &::-webkit-scrollbar-thumb:hover {
      background-color: ${theme.colors.background.hover};
    }

    scrollbar-width: thin;
    scrollbar-color: ${theme.colors.background.hover} transparent;
  `}
`

export const MenuList = styled(MuiMenuList)`
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  padding: 0;
  max-height: 240px;
`

export const MenuItem = styled(MuiMenuItem)`
  ${({ theme }) => css`
    height: 48px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.5px;
    color: ${theme.colors.gray.dark};

    &.Mui-selected {
      background: ${theme.colors.background.hover} !important;
    }

    &&:hover,
    &&:focus,
    &&:focus-visible,
    &&.Mui-selected,
    &&.Mui-focusVisible,
    &&[aria-selected='true'] {
      transition: all ease 0.3s;
      background-color: ${theme.colors.background.hover} !important;
    }
  `}
`

export const ErrorMessage = styled(Box)`
  ${({ theme }) => css`
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    padding: 4px 0 0 0;
    color: ${theme.colors.error.color};
  `}
`

export const IconBox = styled(Box)<{ error?: boolean; isDisabled?: boolean }>`
  ${({ theme, error, isDisabled }) => css`
    padding-right: 12px;
    padding-top: 4px;
    color: ${error ? theme.colors.error.color : theme.colors.gray.dark};
    opacity: ${isDisabled ? 0.5 : 1};
    cursor: ${isDisabled ? 'not-allowed' : 'pointer'};
  `}
`
